<form [formGroup]="dispatchForm" (ngSubmit)="onSubmit()">
  <div class="modal-header">
    <h4 class="modal-title">👉 Update LR Details ?</h4>
    <button
      type="button"
      class="btn-close"
      aria-label="Close"
      (click)="cancel()"
    ></button>
  </div>

  <div class="modal-body">
    <div
      class="row g-2 mb-3 mt-2 align-items-center justify-content-between flex-nowrap"
    >
      <div class="col-lg-6">
        <label class="form-label text-body1 d-block">Invoice Number *</label>
        <input
          type="text"
          class="form-control text-body1"
          placeholder="Enter invoice number"
          formControlName="invoiceNumber"
        />
      </div>
      <!-- <div class="col-lg-4">
        <label class="form-label text-body1 d-block">Mode of payment *</label>
        <input
          type="text"
          class="form-control text-body1"
          placeholder="Enter mode of payment"
          formControlName="paymentMode"
        />
      </div> -->
      <div class="col-lg-6">
        <label class="form-label text-body1 d-block">E-Way Bill No. *</label>
        <input
          type="text"
          class="form-control text-body1"
          placeholder="Enter e-way bill no."
          formControlName="eWayBillNo"
        />
      </div>
    </div>
  </div>

  <div class="modal-footer">
    <div class="d-flex align-items-center justify-content-between w-100">
      <button
        class="btn btn-primary"
        type="submit"
        [disabled]="dispatchForm.invalid || isSubmitting"
      >
        Update LR
      </button>

      <!-- <button class="btn btn-secondary" type="button" (click)="cancel()">
        Close
      </button> -->
    </div>
  </div>
</form>
<div #lrTemplate class="lr-template lr-offscreen">
  <!-- Put your pretty Figma design here. Example: -->
  <!-- lr pdf html start here -->
  <body style="margin: 0; padding: 0px; font-family: Arial, sans-serif; font-size: 12px; color: #000; background: #fff;">
    <table style="width: 100%; max-width: 750px; margin: 0 auto; border-collapse: collapse; background: #fff; page-break-inside: avoid;">
        <tr>
            <td style="padding: 0;">
                <table style="width: 100%; border-collapse: collapse; background: #f0f4f8; padding: 15px;">
                    <tr>
                        <td style="width: 70%; vertical-align: middle; padding: 12px;">
                            <div style="font-size: 24px; font-weight: bold; color: #1e4a6b; margin-bottom: 5px;">Always Roadways Private Limited</div>
                            <div style="font-size: 10px; line-height: 1.6; color: #333;">
                                <strong>GSTIN:</strong> 24ABECA2356H1ZX | <strong>PAN:</strong> ABECA2356H ✉ info@alwaysroadways.in  ☎ +91 99094 01001<br>
                                📍 G-5 Siromany 142, B/h Real Plaza, Nr. Omkar CNG Pump, Lalpar, Morbi – 363042 (Guj.)
                            </div>
                        </td>
                        <td style="width: 30%; text-align: right; vertical-align: middle; padding: 12px;">
                            <img src="assets/images/tiles_drop_logo.png">
                        </td>
                    </tr>
                </table>
            </td>
        </tr>
        <tr>
            <td style="padding: 0; padding-top: 8px;">
                <table style="width: 100%; border-collapse: collapse; border: 1px solid #C6DBD8;">
                    <tr>
                        <td style="padding: 6px 10px; background: #f9f9f9; font-weight: bold; color: #1e4a6b; border-bottom: 1px solid #C6DBD8;" colspan="6">LORRY RECEIPT DETAILS</td>
                    </tr>
                    <tr>
                        <td style="padding: 6px 8px; border: 1px solid #C6DBD8; width: 16.66%; background: #f9f9f9; font-weight: bold; font-size: 10px;">LR Number</td>
                        <td style="padding: 6px 8px; border: 1px solid #C6DBD8; width: 16.66%; background: #f9f9f9; font-weight: bold; font-size: 10px;">LR Date</td>
                        <td style="padding: 6px 8px; border: 1px solid #C6DBD8; width: 16.66%; background: #f9f9f9; font-weight: bold; font-size: 10px;">Vehicle Number</td>
                        <td style="padding: 6px 8px; border: 1px solid #C6DBD8; width: 16.66%; background: #f9f9f9; font-weight: bold; font-size: 10px;">From</td>
                        <td style="padding: 6px 8px; border: 1px solid #C6DBD8; width: 16.66%; background: #f9f9f9; font-weight: bold; font-size: 10px;">To</td>
                        <td style="padding: 6px 8px; border: 1px solid #C6DBD8; width: 16.66%; background: #f9f9f9; font-weight: bold; font-size: 10px;">Delivery at</td>
                    </tr>
                    <tr>
                        <td style="padding: 6px 8px; border: 1px solid #C6DBD8;">{{ initialData?.truckAssignment?.lrNumber }}</td>
                        <td style="padding: 6px 8px; border: 1px solid #C6DBD8;">{{ today | date : 'dd/MM/yyyy' }}</td>
                        <td style="padding: 6px 8px; border: 1px solid #C6DBD8;">{{ initialData?.truckAssignment?.truckNo }}</td>
                        <td style="padding: 6px 8px; border: 1px solid #C6DBD8;">{{ initialData?.pickup?.address?.city }}</td>
                        <td style="padding: 6px 8px; border: 1px solid #C6DBD8;">{{ initialData?.order?.type === 'full-load' ? initialData?.deliveries[0]?.address?.city: initialData?.order?.sharedDelivery?.address?.city  }}</td>
                        <td style="padding: 6px 8px; border: 1px solid #C6DBD8;">{{ initialData?.order?.type === 'part-load-door'? 'Godown' : 'Doorstep' }}</td>
                    </tr>
                </table>
            </td>
        </tr>
        <tr>
            <td style="padding: 0; padding-top: 8px;">
                <table style="width: 100%; border-collapse: collapse;">
                    <tr>
                        <td style="width: 48%; vertical-align: top; padding-right: 0px;">
                            <table style="width: 100%; border-collapse: collapse; border: 1px solid #C6DBD8;">
                                <tr>
                                    <td style="padding: 8px 10px; background: #f9f9f9; font-weight: bold; color: #1e4a6b; border-bottom: 1px solid #C6DBD8;">CONSIGNOR (SENDER)</td>
                                </tr>
                                <tr>
                                    <td style="padding: 8px 10px;">
                                        <div style="font-weight: bold; margin-bottom: 5px;">{{ initialData?.pickup?.address?.companyName }}</div>
                                        <div style="font-size: 10px; line-height: 1.6;">
                                            {{ initialData?.pickup?.address?.locality }}, {{ initialData?.pickup?.address?.city }} - {{ initialData?.pickup?.address?.pincode }}<br>
                                            <!-- <strong>GSTIN:</strong> 27AABCU9603R1ZM -->
                                        </div>
                                    </td>
                                </tr>
                            </table>
                        </td>
                        <td style="width: 2%;"></td>
                        <td style="width: 48%; vertical-align: top; padding-right: 0px;">
                            <table style="width: 100%; border-collapse: collapse; border: 1px solid #C6DBD8;">
                                <tr>
                                    <td style="padding: 8px 10px; background: #f9f9f9; font-weight: bold; color: #1e4a6b; border-bottom: 1px solid #C6DBD8;">CONSIGNEE (RECEIVER)</td>
                                </tr>
                                <tr>
                                    <td style="padding: 8px 10px;">
                                        <div style="font-weight: bold; margin-bottom: 5px;">{{ initialData?.orderBy?.companyName }}</div>
                                    </td>
                                </tr>
                            </table>
                        </td>
                    </tr>
                </table>
            </td>
        </tr>
        <tr>
            <td style="padding: 0; padding-top: 8px;">
                <table style="width: 100%; border-collapse: collapse; border: 1px solid #000; page-break-inside: avoid;">
                    <tr style="background: #1e5570; color: #fff;">
                        <td style="padding: 8px; border: 1px solid #B3C9D1; width: 8%; text-align: center; font-weight: bold;">SR No</td>
                        <td style="padding: 8px; border: 1px solid #B3C9D1; width: 30%; font-weight: bold;">Description of Goods</td>
                        <td style="padding: 8px; border: 1px solid #B3C9D1; width: 5%; text-align: center; font-weight: bold;">HSN</td>
                        <td style="padding: 8px; border: 1px solid #B3C9D1; width: 10%; text-align: center; font-weight: bold;">Qty</td>
                        <td style="padding: 8px; border: 1px solid #B3C9D1; width: 20%; text-align: center; font-weight: bold;">Actual WT (KG)</td>
                        <td style="padding: 8px; border: 1px solid #B3C9D1; width: 25%; text-align: center; font-weight: bold;">Charge WT (KG)</td>
                    </tr>
                    <ng-container *ngIf="initialData?.order?.type === 'full-load'"> 
                      <ng-container
                  *ngFor="let delivery of initialData?.deliveries;
                    let di = index"
                >
                  <tr *ngFor="let it of delivery.items; let itt = index">
                    <td style="padding: 8px; border: 1px solid #B3C9D1; text-align: center;">{{ itt + 1 }}</td>
                    <td style="padding: 8px; border: 1px solid #B3C9D1; text-align: center;">{{ it?.product?.name }} {{ it?.product?.subItems?.name ? '- ' + it?.product?.subItems?.name : '' }} </td>
                    <td style="padding: 8px; border: 1px solid #B3C9D1; text-align: center;">HSN</td>
                    <td style="padding: 8px; border: 1px solid #B3C9D1; text-align: center;">{{ it?.planned?.qty }}</td>
                    <td style="padding: 8px; border: 1px solid #B3C9D1; text-align: center;">{{ it?.planned?.weight }}</td>
                    <td style="padding: 8px; border: 1px solid #B3C9D1; text-align: center;">{{ it?.planned?.chargeWeight }}</td>
                  </tr>
                </ng-container>

                      </ng-container>
                     <ng-container *ngIf="initialData?.order?.type === 'part-load-door' || initialData?.order?.type === 'part-load-office'">
            <tr *ngFor="let it of initialData?.pickup?.items; let itt = index">
                <td style="padding: 8px; border: 1px solid #B3C9D1; text-align: center;">{{ itt + 1 }}</td>
                    <td style="padding: 8px; border: 1px solid #B3C9D1; text-align: center;">{{ it?.product?.name }} {{ it?.product?.subItems?.name ? '- ' + it?.product?.subItems?.name : '' }} </td>
                    <td style="padding: 8px; border: 1px solid #B3C9D1; text-align: center;">HSN</td>
                    <td style="padding: 8px; border: 1px solid #B3C9D1; text-align: center;">{{ it?.planned?.qty }}</td>
                    <td style="padding: 8px; border: 1px solid #B3C9D1; text-align: center;">{{ it?.planned?.weight }}</td>
                    <td style="padding: 8px; border: 1px solid #B3C9D1; text-align: center;">{{ it?.planned?.chargeWeight }}</td>
                      </tr>
                    </ng-container>
                    <tr style="background: #ECF3F2; font-weight: bold;">
                        <td style="padding: 8px; border: 1px solid #B3C9D1;" colspan="3">Total</td>
                        <td style="padding: 8px; border: 1px solid #B3C9D1; text-align: center;">{{initialData?.totals?.actualQty}}</td>
                        <td style="padding: 8px; border: 1px solid #B3C9D1; text-align: center;">{{initialData?.totals?.actualWeight}}</td>
                        <td style="padding: 8px; border: 1px solid #B3C9D1; text-align: center;">{{ initialData?.order.type === 'full-load' ? initialData?.isOrderWeightLessThanActual ===  true ? initialData?.totals?.totalWeight : initialData?.totals?.actualWeight :  totalChargeWeight}}</td>
                    </tr>
                </table>
            </td>
        </tr>
        <tr>
            <td style="padding: 0; padding-top: 8px;">
                <table style="width: 100%; border-collapse: collapse;">
                    <tr>
                        <td style="width: 43%; vertical-align: top; padding-right: 0px;">
                            <table style="width: 100%; border-collapse: collapse; border: 1px solid #C6DBD8;">
                                <tr>
                                    <td style="padding: 8px 10px; background: #f9f9f9; font-weight: bold; color: #1e4a6b; border-bottom: 1px solid #C6DBD8;">FREIGHT CHARGES</td>
                                </tr>
                                <tr>
                                    <td style="padding: 0;">
                                        <table style="width: 100%; border-collapse: collapse;">
                                            <tr>
                                                <td style="padding: 8px; border-bottom: 1px solid #C6DBD8; width: 70%;">Freight Charges</td>
                                                <td style="padding: 8px; border-bottom: 1px solid #C6DBD8; text-align: right;">0</td>
                                            </tr>
                                            <tr>
                                                <td style="padding: 8px; border-bottom: 1px solid #C6DBD8;">Loading / Other</td>
                                                <td style="padding: 8px; border-bottom: 1px solid #C6DBD8; text-align: right;">0</td>
                                            </tr>
                                            <tr style="background: #ECF3F2; font-weight: bold;">
                                                <td style="padding: 8px 10px;">Total Freight</td>
                                                <td style="padding: 8px 10px; text-align: right;">0</td>
                                            </tr>
                                        </table>
                                    </td>
                                </tr>
                            </table>
                        </td>
                        <td style="width: 2%;"></td>
                        <td style="width: 57%; vertical-align: top; padding-left: 0px;">
                            <table style="width: 100%; border-collapse: collapse; border: 1px solid #C6DBD8;">
                                <tr>
                                    <td style="padding: 8px 10px; background: #f9f9f9; font-weight: bold; color: #1e4a6b; border-bottom: 1px solid #C6DBD8;">GST DETAILS</td>
                                </tr>
                                <tr>
                                    <td style="padding: 4px 8px;">
                                        <table style="width: 100%; border-collapse: collapse;">
                                            <tr>
                                                <td style="padding: 4px 0;">
                                                    <span style="padding: 4px 0; font-size: 11px; font-weight: bold; margin-right: 10px;">GST Type</span>
                                                    <label style="margin-right: 15px;"><input type="radio" name="gst" checked> CGST + SGST</label>
                                                    <label><input type="radio" name="gst"> IGST</label>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td style="padding: 8px 0 0;">
                                                    <table style="width: 100%; border-collapse: collapse;">
                                                        <tr>
                                                            <td style="width: 50%; padding-right: 5px;">
                                                                <div style="font-size: 10px; font-weight: bold; margin-bottom: 3px;">GST %</div>
                                                                <div style="background: #ECF3F2; padding: 6px; border: 1px solid #C6DBD8;">5%</div>
                                                            </td>
                                                            <td style="width: 50%; padding-left: 5px;">
                                                                <div style="font-size: 10px; font-weight: bold; margin-bottom: 3px;">RCM</div>
                                                                <div style="background: #ECF3F2; padding: 6px; border: 1px solid #C6DBD8;">Yes</div>
                                                            </td>
                                                        </tr>
                                                    </table>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td style="padding: 4px 0;">
                                                    <span style="padding: 4px 0; font-size: 11px; font-weight: bold; margin-right: 10px;">Payable By</span>
                                                    <label style="margin-right: 10px;"><input type="radio" name="payable" checked> Consignor</label>
                                                    <label style="margin-right: 10px;"><input type="radio" name="payable"> Consignee</label>
                                                    <label><input type="radio" name="payable"> Transporter</label>
                                                </td>
                                            </tr>
                                        </table>
                                    </td>
                                </tr>
                            </table>
                        </td>
                    </tr>
                </table>
            </td>
        </tr>

        <tr>
            <td style="padding: 0; padding-top: 8px;">
                <table style="width: 100%; border-collapse: collapse; border: 1px solid #C6DBD8;">
                    <tr>
                        <td style="padding: 6px 10px; background: #f9f9f9; font-weight: bold; color: #1e4a6b; border-bottom: 1px solid #C6DBD8;" colspan="4">PAYMENT & TRANSPORT DETAILS</td>
                    </tr>
                    <tr>
                        <td style="padding: 6px 8px; border: 1px solid #C6DBD8; width: 16.66%; background: #f9f9f9; font-weight: bold; font-size: 10px;">Mode of Payment</td>
                        <td style="padding: 6px 8px; border: 1px solid #C6DBD8; width: 16.66%; background: #f9f9f9; font-weight: bold; font-size: 10px;">E-Way Bill No</td>
                        <td style="padding: 6px 8px; border: 1px solid #C6DBD8; width: 16.66%; background: #f9f9f9; font-weight: bold; font-size: 10px;">Invoice No</td>
                        <td style="padding: 6px 8px; border: 1px solid #C6DBD8; width: 16.66%; background: #f9f9f9; font-weight: bold; font-size: 10px;">Insurance</td>
                    </tr>
                    <tr>
                        <td style="padding: 6px 8px; border: 1px solid #C6DBD8;">TBB</td>
                        <td style="padding: 6px 8px; border: 1px solid #C6DBD8;">{{ dispatchForm.get('eWayBillNo')?.value || '-' }}</td>
                        <td style="padding: 6px 8px; border: 1px solid #C6DBD8;">{{ dispatchForm.get('invoiceNumber')?.value || '-' }}</td>
                        <td style="padding: 6px 8px; border: 1px solid #C6DBD8;">Not Covered</td>
                    </tr>
                </table>
            </td>
        </tr>

         <tr>
            <td style="padding: 0; padding-top: 8px;">
                <table style="width: 100%; border-collapse: collapse; border: 1px solid #C6DBD8;">
                    <tr>
                        <td style="padding: 6px 10px; background: #f9f9f9; font-weight: bold; color: #1e4a6b; border-bottom: 1px solid #C6DBD8;" colspan="4">BANK DETAILS FOR PAYMENT</td>
                    </tr>
                    <tr>
                        <td style="padding: 6px 8px; border: 1px solid #C6DBD8; width: 16.66%; background: #f9f9f9; font-weight: bold; font-size: 10px;">Bank Name</td>
                        <td style="padding: 6px 8px; border: 1px solid #C6DBD8; width: 16.66%; background: #f9f9f9; font-weight: bold; font-size: 10px;">Account Name</td>
                        <td style="padding: 6px 8px; border: 1px solid #C6DBD8; width: 16.66%; background: #f9f9f9; font-weight: bold; font-size: 10px;">Account Number</td>
                        <td style="padding: 6px 8px; border: 1px solid #C6DBD8; width: 16.66%; background: #f9f9f9; font-weight: bold; font-size: 10px;">IFSC Code</td>
                    </tr>
                    <tr>
                        <td style="padding: 6px 8px; border: 1px solid #C6DBD8;">HDFC Bank</td>
                        <td style="padding: 6px 8px; border: 1px solid #C6DBD8;">Always Roadways Pvt Ltd</td>
                        <td style="padding: 6px 8px; border: 1px solid #C6DBD8;">50200012345678</td>
                        <td style="padding: 6px 8px; border: 1px solid #C6DBD8;">HDFC0001234</td>
                    </tr>
                </table>
            </td>
        </tr>

        <tr>
            <td style="padding: 0; padding-top: 8px;">
                <table style="width: 100%; border-collapse: collapse; border: 1px solid #C6DBD8;">
                    <tr>
                        <td style="padding: 6px 10px; background: #f9f9f9; font-weight: bold; color: #1e4a6b; border-bottom: 1px solid #C6DBD8;" colspan="4">Terms & Conditions:</td>
                    </tr>
                    <tr>
                        <td style="padding: 6px 10px; font-size: 10px; line-height: 1.6;">
                            This consignment is subject to the standard terms and conditions of carriage. The company shall not be liable for any loss, damage, or delay arising from acts of God, accidents, riots, strikes, or other causes beyond our control.
                        </td>   
                    </tr>
                </table>
            </td>
        </tr>
        
        <tr>
            <td style="padding: 8px 0;">
                <table style="width: 100%; border-collapse: collapse;">
                    <tr>
                        <td style="width: 70%; vertical-align: bottom; padding: 10px 0;">
                            <div style="font-size: 10px; font-style: italic; text-align: center;">
                                Digitally Generated Lorry Receipt – No Physical Signature Required
                            </div>
                        </td>
                        <td style="width: 30%; text-align: right; vertical-align: bottom; padding: 10px 0;">
                           <img
                        src="assets/images/signature.png"
                        alt=""
                        style="width: 150px"
                      />
                            <div style="border-top: 1px solid #000; padding-top: 5px; margin-top: 10px; text-align: center; font-size: 11px; font-weight: bold;">
                                Authorised Signatory<br>
                                <span style="font-size: 10px; font-weight: normal;">Always Roadways Pvt Ltd</span>
                            </div>
                        </td>
                    </tr>
                </table>
            </td>
        </tr>
    </table>
</body>
  <!-- lr pdf html end here -->
</div>
